import React from 'react';

interface props {
    children: React.ReactNode
}

const FormSubmitionError = ({ children }: props): JSX.Element => {
    return (
        <div className="note p-4 bg-error text-white rounded-20">
            {children}
        </div>
    );
};

export default FormSubmitionError;
